import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { benefitsMock } from '../../mock';

import { styles } from './BenefitsSection.styles';

export function BenefitsSection() {
  const slots = styles();
  const t = useTranslations();

  const { benefits } = benefitsMock(t);

  return (
    <div className={slots.base()}>
      <h2 className={slots.title()}>
        {t('article.page.loyalty.benefits.title')}
      </h2>
      <div className={slots.benefits()}>
        {benefits.map((benefit) => (
          <div
            className={slots.benefitsItem()}
            key={benefit.description}
          >
            <div className={slots.benefitsItemIcon()}>
              <Image
                src={benefit.icon}
                alt={benefit.description}
                fill
              />
            </div>
            <div className={slots.benefitsItemTitle()}>
              {benefit.description}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
